import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { getSelectedStore } from 'x/redux/selectors'
import * as profileActions from 'x/modules/profile/ProfileState'

import CustomerEditProfileView from './CustomerEditProfileView'

export default connect(
  (state) => ({
    selectedStore: getSelectedStore(state),
    // myStores: getMyStores(state),
  }),
  (dispatch) => {
    return {
      updateOrgMemberProfileDetail: bindActionCreators(profileActions.updateOrgMemberProfileDetail, dispatch),
      // fetchInitializeData: bindActionCreators(StoreState.fetchInitializeData, dispatch),
      // fetchMyStore: bindActionCreators(StoreState.fetchMyStore, dispatch),
      dispatch,
    }
  }
)(CustomerEditProfileView)
